import script from "./ApplicationsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationsList.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationsList.vue?vue&type=style&index=0&id=4da19e8d&lang=scss"

const __exports__ = script;

export default __exports__